import { useAuth } from '../../context/AuthContext';
import './Sidebar.css';

const ALL_MENU_ITEMS = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    roles: ['ROLE_ADMIN', 'ROLE_MANAGER'],
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7" />
        <rect x="14" y="3" width="7" height="7" />
        <rect x="14" y="14" width="7" height="7" />
        <rect x="3" y="14" width="7" height="7" />
      </svg>
    ),
  },
  {
    id: 'userManagement',
    label: 'User Management',
    roles: ['ROLE_ADMIN'],
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    id: 'uploadExcel',
    label: 'Upload Excel',
    roles: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_USER'],
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="17 8 12 3 7 8" />
        <line x1="12" y1="3" x2="12" y2="15" />
      </svg>
    ),
  },
  {
    id: 'contacts',
    label: 'Contacts',
    roles: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_USER'],
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    id: 'companies',
    label: 'Companies',
    roles: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_USER'],
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2" />
        <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
        <line x1="12" y1="12" x2="12" y2="16" />
        <line x1="10" y1="14" x2="14" y2="14" />
      </svg>
    ),
  },
  {
    id: 'dncBounce',
    label: 'DNC / Bounce',
    roles: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_USER'],
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
      </svg>
    ),
  },
];

const ROLE_DISPLAY = {
  ROLE_ADMIN:   { label: 'Administrator', color: '#7c3aed', bg: '#ede9fe' },
  ROLE_MANAGER: { label: 'Manager',       color: '#0891b2', bg: '#cffafe' },
  ROLE_USER:    { label: 'User',           color: '#1d4ed8', bg: '#dbeafe' },
};

export default function Sidebar({ activeModule, onModuleChange, collapsed, onMouseEnter, onMouseLeave }) {
  const { auth, logout } = useAuth();

  const visibleItems = ALL_MENU_ITEMS.filter(item =>
    item.roles.includes(auth?.role)
  );

  const roleInfo = ROLE_DISPLAY[auth?.role] || ROLE_DISPLAY.ROLE_USER;
  const initials = auth?.username ? auth.username.slice(0, 2).toUpperCase() : '??';

  return (
    <aside
      className={`sidebar ${collapsed ? 'collapsed' : ''}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="sidebar-logo">
        <div className="logo-icon">
          <svg viewBox="0 0 32 32" fill="none">
            <rect width="32" height="32" rx="8" fill="#1d4ed8" />
            <path d="M8 8h6v16H8z" fill="white" opacity="0.9" />
            <path d="M17 8h7l-4 8 4 8h-7l4-8z" fill="white" opacity="0.7" />
          </svg>
        </div>
        {!collapsed && (
          <div className="logo-text">
            <span className="logo-title">LDM</span>
            <span className="logo-subtitle">Lead Data Manager</span>
          </div>
        )}
      </div>

      <div className="sidebar-divider" />

      <nav className="sidebar-nav">
        <span className={`sidebar-nav-label ${collapsed ? 'hidden' : ''}`}>NAVIGATION</span>
        {visibleItems.map((item) => (
          <button
            key={item.id}
            className={`sidebar-item ${activeModule === item.id ? 'active' : ''}`}
            onClick={() => onModuleChange(item.id)}
            title={collapsed ? item.label : ''}
          >
            <span className="sidebar-item-icon">{item.icon}</span>
            {!collapsed && <span className="sidebar-item-label">{item.label}</span>}
            {activeModule === item.id && !collapsed && <span className="sidebar-item-dot" />}
          </button>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-divider" />
        <div className={`sidebar-user ${collapsed ? 'collapsed' : ''}`}>
          <div className="sidebar-avatar">{initials}</div>
          {!collapsed && (
            <>
              <div className="sidebar-user-info">
                <span className="sidebar-user-name">{auth?.username}</span>
                <span className="sidebar-user-role-badge" style={{ color: roleInfo.color, background: roleInfo.bg }}>
                  {roleInfo.label}
                </span>
              </div>
              <button className="sidebar-logout" onClick={logout} title="Sign out">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
              </button>
            </>
          )}
        </div>
      </div>
    </aside>
  );
}
